<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: lectureIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="chalkboard-teacher"
      :style="{ color: lectureIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Palestra</span>
  </div>
</template>

<script>
export default {
  props: ["lectureIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
